import { useScreenConfig } from '../../config/screens.context';
import { bem } from '../../core/design/bem';
import '../SocialWall.scss';
import { defaultReactions } from '../SocialWallCard';
import SocialWallReaction from '../SocialWallReaction';
import { SocialWallMessage } from '../types/SocialWallTypes';

const css = bem('SocialWall__Metadata');

type HoverTileProps = {
  item: SocialWallMessage;
};

const HoverTile = (props: HoverTileProps): JSX.Element => {
  const { item: post } = props;
  const { width, height } = post;
  const { reactions = defaultReactions } = useScreenConfig('socialWall');
  return (
    <div className={css()} style={{ width, height }}>
      {reactions.map((reaction: any) => (
        <SocialWallReaction key={reaction.key} item={reaction} post={post} />
      ))}
    </div>
  );
};

export default HoverTile;
